import { useSessionStore } from '@/stores/useSessionStore'
import { WidgetPopupSettings } from '@/types'
import { Flex } from '@alpine-iq/ui-library'

export default function LogoImage({ withinCover = false }) {
  const uid = useSessionStore((state) => state.currentUID)
  const widgetSettings = useSessionStore((state) => state.widgetSettings)
  const popupSettings = widgetSettings?.popupSettings || {}

  const { logoType, logoSrc } = getLogoSource(uid || '', popupSettings)

  const enableLogo = popupSettings?.enableLogo !== false
  if (!enableLogo || !logoSrc) return null

  if (logoType === 'avatar') {
    const squareLogo = popupSettings?.images?.squareLogo || false
    const logoPlacement = popupSettings?.images?.logoPlacement || 'belowCover'
    if (logoPlacement === 'belowCover' && withinCover) return null
    return (
      <Flex center>
        <div
          css={`
						height: 80px;
						width: 80px;
						border-radius: ${!squareLogo ? '50%' : '8px'};
						overflow: hidden;
					`}
        >
          <img src={logoSrc} alt={logoType} height={80} width={80} />
        </div>
      </Flex>
    )
  }

  return (
    <Flex center>
      <img
        src={logoSrc}
        alt={logoType}
        style={{
          minWidth: 200,
          maxWidth: '60%',
          width: '100%',
          height: 'auto',
        }}
      />
    </Flex>
  )
}

function getLogoSource(
  uid: string,
  popupSettings: WidgetPopupSettings
): {
  logoType: string
  logoSrc: string
} {
  let logoType = popupSettings?.logoOption || 'avatar'
  let logoSrc = ''

  if (logoType === 'full-logo') {
    logoSrc = popupSettings?.images?.fullLogo || ''
  }
  if (logoType === 'full-logo' && !logoSrc) {
    logoType = 'avatar'
  }
  if (logoType === 'avatar') {
    const host = location.origin.replace('lab-dev', 'lab')
    const defaultAvatar = `https://lab.alpineiq.com/avatar/${uid || ''}`
    logoSrc = popupSettings?.images?.logo || defaultAvatar
  }

  return { logoType, logoSrc }
}
